import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// -----------------------------------------------------------------------------
// Category data
// -----------------------------------------------------------------------------
const categoryCourses = {
  "Full Stack Development": [
    { title: "Full Stack Java Development",    duration: "5 Months", logo: "/assets/images/courselogo/java.webp",       link:"/course-details/Full-Stack-Java-Development" },
    { title: "Full Stack Python Development",  duration: "5 Months", logo: "/assets/images/courselogo/python.webp",     link:"/course-details/Full-Stack-Python-Development" },
    { title: "Full Stack .Net Development",    duration: "5 Months", logo: "/assets/images/courselogo/dot_net.webp",    link:"/course-details/Full-Stack-Dot-Net-Development" },
  ],
  "MERN Stack Development": [
    { title: "MERN Stack Development",         duration: "5 Months", logo: "/assets/images/courselogo/mern.webp",       link:"/course-details/MERN-Stack-Development" },
  ],
  "Software Testing": [
    { title: "Manual & Automation Testing",    duration: "5 Months", logo: "/assets/images/courselogo/testing.webp",    link:"/course-details/Software-Testing" },
  ],
  "Cyber Security": [
    { title: "Cyber Security",                 duration: "6 Months", logo: "/assets/images/courselogo/cs.webp",         link:"/course-details/Cyber-Security" },
  ],
  "Cloud Computing": [
    { title: "AWS & DevOps",                   duration: "5 Months", logo: "/assets/images/courselogo/mca.webp",        link:"/course-details/Cloud-Computing" },
  ],
  "Data Science & Data Analytics": [
    { title: "Data Science & Data Analytics",  duration: "6 Months", logo: "/assets/images/courselogo/datascience.webp",link:"/course-details/Data-Science-And-Data-Analytics" },
    { title: "Data Analytics",                 duration: "4 Months", logo: "/assets/images/courselogo/da.webp",         link:"/course-details/Data-Analytics" },
  ],
  "Android Development": [
    { title: "Android Development",            duration: "5 Months", logo: "/assets/images/courselogo/android.webp",    link:"/course-details/Android-Development" },
  ],
  "Digital Marketing": [
    { title: "Digital Marketing",              duration: "3 Months", logo: "/assets/images/courselogo/digitalmarketing.webp", link:"/course-details/Digital-Marketing" },
  ],
};

// Helper for unique, Bootstrap‑friendly IDs
const slugify = (str) => str.toLowerCase().replace(/[^a-z0-9]+/g, '-');

const Ourcourses = () => {
  // Desktop view uses the sidebar to pick a single category
  const [selectedCategory, setSelectedCategory] = useState("Full Stack Development");
  const desktopCourses = categoryCourses[selectedCategory];

  return (
    <div className="courseslinear">
      <div className="container my-2">
        <div className="row">
          {/* Header */}
          <div className="col-md-12 p-2">
            <h1 className="mb-2 myfont1 text-dark fw-bold pt-2">Explore Our Courses</h1>
            <p className="text-muted">
              Choose from a wide range of IT courses designed to boost your career in software development,
              testing, cloud, data science, and more.
            </p>
          </div>

          {/* ------------------------------------------------------------------
             DESKTOP VIEW  ≥ sm
             ------------------------------------------------------------------ */}
          <div className="d-none d-sm-block">
            <div className="row">
              {/* Category sidebar */}
              <div className="col-md-3">
                <div className="list-group p-1 myfont1">
                  {Object.keys(categoryCourses).map((cat) => (
                    <button
                      key={cat}
                      type="button"
                      className={`mb-1 rounded-0 fw-bold list-group-item list-group-item-action ${
                        selectedCategory === cat ? 'active' : ''
                      }`}
                      onClick={() => setSelectedCategory(cat)}
                      aria-pressed={selectedCategory === cat}
                    >
                      {cat}
                    </button>
                  ))}
                </div>
              </div>

              {/* Course cards */}
              <div className="col-md-9">
                <div className="row myfont1">
                  {desktopCourses.map((course, index) => (
                    <div className="col-md-4 col-12 mb-4" key={index}>
                      <article className="border p-3 rounded shadow-sm h-100 bg-white">
                        <img
                          src={course.logo}
                          alt={`${course.title} Course Logo`}
                          className="mb-3"
                          loading="lazy"
                          style={{ maxWidth: 100 }}
                        />
                        <h5 className="fw-bold">
                          {course.title === "Data Analytics" ? <><br />{course.title}</> : course.title}
                        </h5>
                        <p className="text-muted">Duration: {course.duration}</p>
                        <Link className="btn btn-outline-info btn-sm" to={course.link}>
                          View Details
                        </Link>
                      </article>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* ------------------------------------------------------------------
             MOBILE VIEW  < sm  (accordion for every category)
             ------------------------------------------------------------------ */}
          {/* Mobile view start */}
          <div className="d-block d-sm-none">
            <div className="accordion" id="accordionCoursesMobile">
              {Object.entries(categoryCourses).map(([category, courses], idx) => {
                const collapseId = `collapse-${slugify(category)}-${idx}`;
                const headingId  = `heading-${slugify(category)}-${idx}`;

                return (
                  <div className="accordion-item mb-1" key={category}>
                    <h2 className="accordion-header bgcolor1 text-white" id={headingId}>
                      <button
                        className="accordion-button collapsed d-flex justify-content-between align-items-center border p-2 fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${collapseId}`}
                        aria-expanded="false"
                        aria-controls={collapseId}
                      >
                        {category}
                        <span className="toggle-icon ms-auto" />
                      </button>
                    </h2>

                    <div
                      id={collapseId}
                      className="accordion-collapse collapse"
                      aria-labelledby={headingId}
                      data-bs-parent="#accordionCoursesMobile"
                    >
                      <div className="row myfont1 p-2">
                        {courses.map((course, i) => (
                          <div className="col-12 mb-3" key={i}>
                            <div className="d-flex align-items-start border p-3 rounded shadow-sm h-100 bg-white">
                              <img
                                src={course.logo}
                                alt={`${course.title} Course Logo`}
                                className="me-3"
                                style={{ width: 70, height: 70, objectFit: 'contain' }}
                                loading="lazy"
                              />
                              <div className="text-start">
                                <h6 className="mb-1 fw-bold">{course.title}</h6>
                                <p className="text-muted mb-2">Duration: {course.duration}</p>
                                <Link className="btn btn-outline-info btn-sm" to={course.link}>
                                  View Details
                                </Link>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {/* Mobile view end */}
        </div>
        <br />
      </div>
    </div>
  );
};

export default Ourcourses;
